import { http, HttpResponse } from "msw";
import baseSseData from "../data/sse";
import hsmsData from "../data/hsms";
const ONE_GB = 1024 * 1024 * 1024;
const encoder = new TextEncoder();
// Global store for the SSE controller and active interval IDs.
let currentSseController = null;
let hsmSeedIntervals = [];
const generateStatusData = ()=>{
    const available_entropy = Math.floor(Math.random() * 400 * ONE_GB);
    const used_memory = 16 * ONE_GB + Math.floor(Math.random() * ONE_GB);
    const available_memory = 32 * ONE_GB - used_memory;
    const statusData = {
        ...baseSseData,
        timestamp: Date.now(),
        system_metrics: {
            ...baseSseData.system_metrics,
            cpu: {
                ...baseSseData.system_metrics.cpu,
                utilization: 20 + Math.random() * 10
            },
            memory: {
                ...baseSseData.system_metrics.memory,
                available: available_memory,
                used: used_memory
            }
        },
        network_metrics: baseSseData.network_metrics.map((metric)=>({
                ...metric,
                rx_rate_mbps: 60 + Math.floor(Math.random() * 5),
                tx_rate_mbps: 5 + Math.floor(Math.random() * 5)
            })),
        utilization: {
            consumption: {
                curr_entropy_bps: 2048 + Math.floor(Math.random() * 256),
                available_entropy
            },
            requests: {
                successful_reqs: Math.floor(Math.random() * 64),
                failed_reqs: Math.floor(Math.random() * 16)
            },
            latency: {
                p_9999: 7.01 + Math.random() * 0.1,
                p_999: 6.98 + Math.random() * 0.1,
                p_99: 6.83 + Math.random() * 0.15,
                p_95: 6.19 + Math.random() * 0.5,
                p_50: 1.8 + Math.random() * 2
            }
        },
        entropy_clients: baseSseData.entropy_clients.map((client)=>{
            const gen = (period)=>{
                const mult = period === "m_15" ? 1 : period === "m_30" ? 2 : 4;
                return {
                    num_requests: Math.round(Math.random() * 10000 * mult),
                    entropy_requested_b: Math.round(Math.random() * ONE_GB * mult)
                };
            };
            return {
                ...client,
                stats: {
                    m_15: gen("m_15"),
                    m_30: gen("m_30"),
                    h_1: gen("h_1"),
                    h_2: gen("h_2"),
                    h_4: gen("h_4"),
                    d_1: gen("d_1"),
                    w_1: gen("w_1")
                }
            };
        })
    };
    return statusData;
};
const sendData = ({ title, data, controller })=>{
    let formattedData;
    const json = JSON.stringify(data);
    if (title) {
        formattedData = `event: ${title}\ndata: ${json}\n\n`;
    } else {
        formattedData = `data: ${json}\n\n`;
    }
    controller.enqueue(encoder.encode(formattedData));
};
const sendHsmData = ({ pkcs11Path, serialNumber, controller, interval })=>{
    const intervalId = setInterval(()=>{
        const success = Math.random() < 0.8;
        let data = {
            pkcs11Path: pkcs11Path,
            serialNumber: serialNumber,
            timestamp: Math.floor(Date.now() / 1000),
            success
        };
        if (!success) {
            data["errorMessage"] = "Sample token error";
        }
        hsmsData.forEach((hsm)=>{
            if (hsm.pkcs11Path !== pkcs11Path) return;
            hsm.tokens.forEach((token)=>{
                if (token.serialNumber !== serialNumber) return;
                token["lastSeedStatus"] = data;
            });
        });
        sendData({
            title: "seed",
            data,
            controller
        });
    }, interval * 1000);
    hsmSeedIntervals.push({
        id: intervalId,
        pkcs11Path: pkcs11Path,
        serialNumber: serialNumber
    });
};
const handler = http.get("/api/admin/system-status", ()=>{
    const stream = new ReadableStream({
        start (controller) {
            currentSseController = controller;
            setInterval(()=>{
                const statusData = generateStatusData();
                sendData({
                    title: "data",
                    data: statusData,
                    controller
                });
            }, 2000);
            const cpu_model = "event: cpu_model\ndata: Intel(R) Xeon(R) E-2388G CPU @ 3.20GHz\n\n";
            controller.enqueue(encoder.encode(cpu_model));
            hsmsData.forEach((hsm)=>{
                hsm.tokens.forEach((token)=>{
                    sendHsmData({
                        pkcs11Path: hsm.pkcs11Path,
                        serialNumber: token.serialNumber,
                        controller,
                        interval: token.seconds
                    });
                });
            });
        }
    });
    return new HttpResponse(stream, {
        headers: {
            "Content-Type": "text/event-stream",
            "Cache-Control": "no-cache",
            "X-Accel-Buffering": "no",
            Connection: "keep-alive"
        }
    });
});
export { currentSseController, hsmSeedIntervals, sendData };
export default handler;
